import React, { useRef, useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Button from "../components/Buttons/Button";
import EventRow from "../components/Events/EventRow";
import EventRowMobile from "../components/Events/EventRowMobile";
import Searchbar from "../components/Searchbar/Searchbar";
import { FLAVOR, icons } from "../helpers/constants";
import * as request from "../services/FetchService";
import { Card, Collapse } from "@mui/material";
import toast from "react-hot-toast";
import DragComponent from "../components/DragComponent";
import EventRowPlaceholder from "../components/Events/EventRowPlaceholder";
import { useIsMobile } from "../helpers/customHooks";
import { translateEvents, translateReverse } from "../helpers/helperFunctions";
import { useContextData } from "../components/ContextData";
import DeleteEvents from "../components/Modals/DeleteEvents";
import SearchbarNew from "../components/Searchbar/SearchbarNew";
import NewButton from "../components/Buttons/NewButton";
import { AnimatePresence, motion } from "framer-motion";
import EventRowNew from "../components/Events/EventRowNew";
import MassShareDeviceRow from "../components/Devices/MassShareDeviceRow";
import MassSharingContent from "../components/Events/MassSharingContent";
import { useSidebarContext } from "../components/Sidebar/SiderbarContext";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const EventsNewMobile = (props) => {
	const MOBILE = useIsMobile();
	const { deviceListCompact, setDeviceListCompact } = useContextData();
	const [deviceList, setDeviceList] = useState([]);
	const [eventListFull, setEventListFull] = useState([]);
	const [eventList, setEventList] = useState([]);
	const { i18n, t } = useTranslation();
	const listInnerRef = useRef();
	const sentinelRef = useRef(null);
	const location = useLocation();
	const navigate = useNavigate();
	const lang = localStorage.getItem("language") ?? "en"

	const [showActions, setShowActions] = useState(false);
	const [deleteToggle, setDeleteToggle] = useState(false);
	const [allSelected, setAllSelected] = useState(false);
	const [deleteArray, setDeleteArray] = useState([]);
	const [loading, setLoading] = useState(true);
	const [toggleDrag, setToggleDrag] = useState(false);
	const [totalPages, setTotalPages] = useState(-1);
	const [currentEvent, setCurrentEvent] = useState(null);
	const [initialLoad, setInitialLoad] = useState(true);
	const [filtersDone, setFiltersDone] = useState(true);

	const [currentFilter, setCurrentFilter] = useState({ type: "date", order: "latest" });
	const [currentTypes, setCurrentTypes] = useState(null);
	const [currentDevices, setCurrentDevices] = useState(null);
	const [currentDateRange, setCurrentDateRange] = useState(null);
	//const [clearSearch, setClearSearch] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchString, setSearchString] = useState("");
	const [visibleEvents, setVisibleEvents] = useState({ events: {}, translations: {} });
	const [loadingBottom, setLoadingBottom] = useState(false);
	const [searchWord, setSearchWord] = useState("");
	const [showFilter, setShowFilter] = useState(false);
	const [showAlarmFilter, setShowAlarmFilter] = useState(false);
	const [showDeviceFilter, setShowDeviceFilter] = useState(false);
	const [showDateFilter, setShowDateFilter] = useState(false);
	const [eventFilters, setEventFilters] = useState([]);
	const [currentEvents, setCurrentEvents] = useState(null);
	const [searchMatches, setSearchMatches] = useState({ devices: null, events: null });
	const [massShare, setMassShare] = useState(false);
	const [sharingStatus, setSharingStatus] = useState();
	const { setActionbarContent, topbarContent, setTopbarContent } = useSidebarContext();
	const [showDelete, setShowDelete] = useState(false);
	const [eventDeleteArray, setEventDeleteArray] = useState([]);
	const [highprio, setHighprio] = useState(true);
	const highprioInitialized = useRef(false);
	const suppressHighprioEffect = useRef(false);
	const didInitSearchRef = useRef(false);


	const [dates, setDates] = useState(() => {
		return {
			startDate: dayjs().subtract(1, "day"),
			endDate: dayjs(),
			preset: 1,
		};
	});

	const [modals, setModals] = useState({
		delete_events: false,
	});

	const hasMore = totalPages === -1 ? true : currentPage < totalPages;

	useEffect(() => {
		const onLanguageChanged = () => {
			setLoading(true);
			setEventList([]);
			setTimeout(() => {
				getEventsPost(currentPage, currentFilter, currentEvents, currentDevices);
			}, 500);
		};

		i18n.on("languageChanged", onLanguageChanged);
		return () => {
			i18n.off("languageChanged", onLanguageChanged);
		};
	}, [i18n]);

	const loadMore = useCallback(() => {
		if (loading || loadingBottom) return;
		if (!hasMore) return;

		setLoading(true);
		setLoadingBottom(true);

		const next = currentPage + 1;
		getEventsPost(next, currentFilter, currentEvents, currentDevices);
		setCurrentPage(next);
	}, [loading, loadingBottom, hasMore, currentPage, currentFilter, currentEvents, currentDevices, currentDateRange]);

	const onScroll = useCallback(() => {}, [loading, loadMore]);

	// --- NEW: grab initial deviceid from location.state once
	const initialDeviceIdRef = useRef(location?.state?.deviceid ?? null);

	useEffect(() => {
		window.addEventListener("scroll", onScroll);

		// IMPORTANT: clear router state immediately so it doesn't stick around
		if (location?.state?.deviceid) {
			navigate(location.pathname, { replace: true, state: null });
		}

		getDevices();
		// don't call getEventsPost() here anymore - we'll call it after getDevices so we can apply selection cleanly
		return () => {
			setActionbarContent(null)
			setTopbarContent(null)
			window.removeEventListener("scroll", onScroll);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (FLAVOR !== "alco") return;
		if (!highprioInitialized.current) {
			highprioInitialized.current = true;
			return;
		}
		if (suppressHighprioEffect.current) {
			suppressHighprioEffect.current = false;
			return;
		}
		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		getEventsPost(1, currentFilter, currentEvents, currentDevices);
	}, [highprio]);

	useEffect(() => {
		if (currentEvent) return;
		if (showDelete) {
			const actioncontent = (
				<div key="menu" className="flex-grow-1 position-relative zlatan m-3">
					<div className="h-100 overflow-auto">
						<div className="d-flex flex-row">
							<NewButton className={`bg-red white rounded24 w-100 p-3 me-2 ${eventDeleteArray?.length < 1 ? "disabled" : ""}`} onClick={() => deleteSelected()}>{`${t("events.delete_selected")} (${eventDeleteArray?.length})`}</NewButton>
							<NewButton className={`bg-red white rounded24 w-100 p-3 ms-2`} onClick={() => toggleModal("delete_events")} btnClass="btn-danger ms-2">
								{t("events.delete_all")}
							</NewButton>
						</div>
					</div>
				</div>
			);
			setActionbarContent(actioncontent);
		} else {
			setActionbarContent(null);
		}
		const topcontent = {
			left: showDelete ? "" : "burger",
			center: <h4 className="mega-center">{t("events.alarms")}</h4>,
			right: (
				<div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={() => setShowDelete(!showDelete)}>
					<img key="settings" src={showDelete ? icons.close : icons.dots_vertical} alt="settings" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
				</div>
			),
		};
		setTopbarContent({ ...topbarContent, ...topcontent });
	}, [showDelete, eventDeleteArray, currentEvent]);

	useEffect(() => {
		if(!showDelete){
			setEventDeleteArray([])
		}
	}, [showDelete])

	useEffect(() => {
		const rootEl = null;

		const observer = new IntersectionObserver(
			(entries) => {
				const [entry] = entries;
				if (entry.isIntersecting) {
					loadMore();
				}
			},
			{
				root: rootEl,
				rootMargin: "200px",
				threshold: 0,
			}
		);

		if (sentinelRef.current) observer.observe(sentinelRef.current);
		return () => observer.disconnect();
	}, [MOBILE, loadMore]);

	const toggleModal = (modalName) => {
		setModals((prevState) => ({
			...prevState,
			[modalName]: !prevState[modalName],
		}));
	};

	const getDevices = async () => {
		try {
			const { data } = await request.get("devices/list");
			if (data?.errorCode === "10003" || data?.errorCode === "10002") {
				localStorage.clear();
				window.location.href = "login";
				return;
			}
			const list = Array.isArray(data?.devices) ? data.devices : [];
			const cleaned = list.map((device) => ({
				deviceid: device.id,
				name: device.name,
				selected: false,
			}));

			const initialDevid = initialDeviceIdRef.current;
			if (initialDevid) {
				// keep UI selection consistent
				const updated = cleaned.map((d) => (d.deviceid === initialDevid ? { ...d, selected: true } : d));
				setDeviceList(updated);

				// apply device filter + fetch first page with that device
				setLoading(true);
				setEventList([]);
				setCurrentPage(1);
				setCurrentDevices([initialDevid]);

				const disableHighprio = !!highprio;
				if (disableHighprio) {
					suppressHighprioEffect.current = true;
					setHighprio(false);
				}

				getEventsPost(1, currentFilter, currentEvents, [initialDevid], {}, !disableHighprio && highprio);
				return;
			}

			setDeviceList(cleaned);

			// no initial device -> normal first fetch
			getEventsPost(1, currentFilter, currentEvents, currentDevices);
		} finally {
		}
	};

	const getEventsPost = async (
		page = currentPage,
		filter = null,
		selectedTypes = currentEvents,
		deviceid = currentDevices,
		matches = {},
		includeHighprio = highprio,
		dateRange = currentDateRange
	) => {
		const matchesSafe = matches ?? {};

		const eventsConstraint = ("searchEvents" in matchesSafe ? matchesSafe.searchEvents : searchMatches?.events) ?? [];
		const devicesConstraint = ("searchDevices" in matchesSafe ? matchesSafe.searchDevices : searchMatches?.devices) ?? [];

		const startdatetime = dateRange?.startDate?.isValid?.() ? dateRange.startDate.toISOString() : null;
		const stopdatetime = dateRange?.endDate?.isValid?.() ? dateRange.endDate.toISOString() : null;

		const combinedTypesSet = new Set([...(selectedTypes ?? []), ...eventsConstraint]);
		if (FLAVOR === "alco" && includeHighprio) {
			combinedTypesSet.add("highprio");
		}
		const combinedTypes = [...combinedTypesSet];
		const combinedDevices = [...new Set([...(deviceid ?? []), ...devicesConstraint])];

		const data = {
			page,
			limit: 100,
			...(filter?.order && { sort: filter.order }),
			...(combinedTypes.length && { type: combinedTypes }),
			...(combinedDevices.length && { deviceid: combinedDevices }),
			...(startdatetime && { startdatetime }),
			...(stopdatetime && { stopdatetime }),
		};

		try {
			const { data: res } = await request.post("", "events/list", data);

			const { events = [], visiblefilterswitch = {}, typeTranslations = {}, totalPages = 0 } = res ?? {};

			if (!events.length) {
				if (page === 1) {
					setEventList([]);
					setEventListFull([]);
					setTotalPages(0);
				}
				return;
			}

			if (page === 1) {
				const selectedSet = new Set(selectedTypes ?? []);
				const filters = Object.entries(visiblefilterswitch)
					.filter(([, value]) => value === true)
					.map(([key]) => ({
						type: key,
						name: typeTranslations[key] ?? key,
						selected: selectedSet.has(key),
					}));
				setEventFilters(filters);
			}

			setEventList((prev) => (page === 1 ? events : [...prev, ...events]));
			setEventListFull((prev) => (page === 1 ? events : [...prev, ...events]));
			setTotalPages(totalPages);
		} catch (err) {
			console.error("Failed to fetch events:", err);
		} finally {
			setLoading(false);
			setLoadingBottom(false);
			setInitialLoad(false);
		}
	};

	useEffect(() => {
		if (allSelected) {
			let updatedDevices = [...eventListFull];
			updatedDevices.map((device) => {
				device.selected = true;
			});
			setEventListFull(updatedDevices);
		} else {
			let updatedDevices = [...eventListFull];
			updatedDevices.map((device) => {
				device.selected = false;
			});
			setEventListFull(updatedDevices);
		}
	}, [allSelected]);

	const selectEvent = (index) => {
		let updatedEvents = [...eventList];
		let correct = updatedEvents.findIndex((id) => id.eventid === index);
		if (index !== -1) {
			var event = updatedEvents[correct];
			event.selected = !event.selected;
			updatedEvents[correct] = event;
			setEventList(updatedEvents);
			setEventListFull(updatedEvents);
		}
	};

	const checkChecked = () => {
		let events = eventList.filter((event) => event.selected);
		let data = {
			eventid: events.map((event) => event.eventid),
		};
		request.post("", "events/delete", data).then((response) => {
			if (response.data) {
				toast.success(t("toast.done"));
				setLoading(true);
				setEventList([]);
				setTimeout(() => {
					setTimeout(() => {
						getEventsPost(1);
						setCurrentPage(1);
					}, 250);
				}, 250);
			}
		});
	};

	const closeActions = () => {
		setDeleteToggle(false);
		setShowActions(false);
		setDeleteArray([]);
	};

	useEffect(() => {
		if (!deleteToggle) {
			let updatedDevices = [...eventListFull];
			updatedDevices.map((device) => {
				device.selected = false;
			});
			setEventListFull(updatedDevices);
		}
	}, [deleteToggle]);

	const showOnMap = () => {};

	const toggleEventFilter = (type) => {
		const updated = eventFilters.map((et) => (et.type === type ? { ...et, selected: !et.selected } : et));
		setEventFilters(updated);

		const selection = updated.filter((i) => i.selected).map((i) => i.type);
		const disableHighprio = selection.length && highprio;
		if (disableHighprio) {
			suppressHighprioEffect.current = true;
			setHighprio(false);
		}
		filterEvents(selection, disableHighprio);
	};

	const toggleDeviceFilter = (deviceid) => {
		const updated = deviceList.map((dev) => (dev.deviceid === deviceid ? { ...dev, selected: !dev.selected } : dev));
		setDeviceList(updated);

		const selection = updated.filter((i) => i.selected).map((i) => i.deviceid);
		const disableHighprio = selection.length && highprio;
		if (disableHighprio) {
			suppressHighprioEffect.current = true;
			setHighprio(false);
		}
		filterDevices(selection, disableHighprio);
	};


	const toggleDateFilter = (disableHighprio = false) => {
		const hasDateRange = dates?.startDate?.isValid?.() && dates?.endDate?.isValid?.();
		const shouldDisableHighprio = hasDateRange && highprio;
		if (shouldDisableHighprio) {
			suppressHighprioEffect.current = true;
			setHighprio(false);
		}
		filterDates(hasDateRange ? { ...dates } : null, shouldDisableHighprio || disableHighprio);
	};

	const filterEvents = (selection, disableHighprio = false) => {
		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		setCurrentEvents(selection);
		getEventsPost(1, currentFilter, selection, currentDevices, {}, !disableHighprio && highprio);
	};

	const filterDevices = (selection, disableHighprio = false) => {
		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		setCurrentDevices(selection);
		getEventsPost(1, currentFilter, currentEvents, selection, {}, !disableHighprio && highprio);
	};

	const filterDates = (selection, disableHighprio = false) => {
		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		setCurrentDateRange(selection);
		getEventsPost(1, currentFilter, currentEvents, currentDevices, {}, !disableHighprio && highprio, selection);
	};

	useEffect(() => {
		if (showDeviceFilter) {
			setShowAlarmFilter(false);
			setShowDateFilter(false);
		}
	}, [showDeviceFilter]);

	useEffect(() => {
		if (showAlarmFilter) {
			setShowDeviceFilter(false);
			setShowDateFilter(false);
		}
	}, [showAlarmFilter]);
	
	useEffect(() => {
		if(showDateFilter){
			setShowDeviceFilter(false);
			setShowAlarmFilter(false);
		}
	}, [showDateFilter])

	useEffect(() => {
		if (!showFilter) {
			setShowDeviceFilter(false);
			setShowAlarmFilter(false);
			setShowDateFilter(false);
		}
	}, [showFilter]);

	useEffect(() => {
		if (!didInitSearchRef.current) {
			didInitSearchRef.current = true;
			return; // <-- prevents initial duplicate fetch
		}
		if (!searchWord || searchWord === "") {
			setSearchMatches({
				devices: null,
				events: null,
			});
			getEventsPost(1, currentFilter, currentEvents, currentDevices, { searchDevices: null, searchEvents: null });
			return;
		}
		const terms = searchWord.trim().toLowerCase().split(/\s+/);
		let matchingDevicesSet = new Set();
		let matchingEventsSet = new Set();

		terms.forEach((term) => {
			let matchingDevices = deviceList.filter((device) => device.name.toLowerCase().includes(term)).map((device) => device.deviceid);
			matchingDevices.forEach((id) => matchingDevicesSet.add(id));

			let termMatches = translateReverse(t, term) || [];
			termMatches.forEach((event) => matchingEventsSet.add(event));
		});

		const devicesArr = [...matchingDevicesSet];
		const eventsArr = [...matchingEventsSet];
		setSearchMatches({ devices: devicesArr, events: eventsArr });

		const disableHighprio = (devicesArr.length || eventsArr.length) && highprio;
		if (disableHighprio) {
			suppressHighprioEffect.current = true;
			setHighprio(false);
		}

		getEventsPost(
			1,
			currentFilter,
			currentEvents,
			currentDevices,
			{
				searchDevices: devicesArr,
				searchEvents: eventsArr,
			},
			!disableHighprio && highprio
		);
	}, [searchWord]); // eslint-disable-line react-hooks/exhaustive-deps

	const eventsByMonth = eventList.reduce((acc, event) => {
		const monthLabel = new Date(event.date).toLocaleString("en-US", {
			month: "long",
			year: "numeric",
		});

		if (!acc[monthLabel]) acc[monthLabel] = [];
		acc[monthLabel].push(event);
		return acc;
	}, {});

	const selectEventForDelete = (id) => {
		setEventDeleteArray((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
	};

	const deleteSelected = () => {
		let data = {
			eventid: eventDeleteArray,
		};
		request.post("", "events/delete", data).then((response) => {
			if (response.data) {
				toast.success(t("toast.done"));
				setLoading(true);
				setEventList([]);
				setTimeout(() => {
					setTimeout(() => {
						getEventsPost(1);
						setCurrentPage(1);
						setEventDeleteArray([]);
					}, 250);
				}, 250);
			}
		});
	};

	const deleteAllEvents = () => {
		let data = {
			delete_all_events: true,
		};
		request.post("", "events/delete", data).then((response) => {
			if (response.data) {
				setLoading(true);
				setEventList([]);
				toast.success(t("toast.done"));
				setTimeout(() => {
					getEventsPost(1);
					setCurrentPage(1);
					toggleModal("delete_events");
				}, 250);
			}
		});
	};

	const selectedEventTypeKeys = (eventFilters ?? []).filter((f) => f.selected).map((f) => f.type);

	const selectedEventTypeLabels = (eventFilters ?? []).filter((f) => f.selected).map((f) => f.name);

	const selectedDeviceIds = (deviceList ?? []).filter((d) => d.selected).map((d) => d.deviceid);

	const selectedDeviceLabels = (deviceList ?? []).filter((d) => d.selected).map((d) => ({ id: d.deviceid, name: d.name }));

	const selectedDateLabel =
		currentDateRange?.startDate?.isValid?.() && currentDateRange?.endDate?.isValid?.()
			? `${currentDateRange.startDate.format("DD/MM HH:mm")} - ${currentDateRange.endDate.format("DD/MM HH:mm")}`
			: null;

	const clearSearch = () => {
		setSearchWord("");
		setSearchMatches({ devices: null, events: null });
		// (optional) refetch with current filters, but no search constraints
		getEventsPost(1, currentFilter, currentEvents, currentDevices, { searchDevices: null, searchEvents: null });
	};

	const clearDateFilter = () => {
		setCurrentDateRange(null);
		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		getEventsPost(1, currentFilter, currentEvents, currentDevices, {}, highprio, null);
	};

	const clearAllFilters = () => {
		setEventFilters((prev) => prev.map((x) => ({ ...x, selected: false })));
		setDeviceList((prev) => prev.map((x) => ({ ...x, selected: false })));
		setCurrentEvents(null);
		setCurrentDevices(null);
		setCurrentDateRange(null);

		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		getEventsPost(1, currentFilter, null, null, { searchDevices: null, searchEvents: null }, highprio, null);
	};

	const removeDeviceChip = (deviceid) => {
		const updated = deviceList.map((d) => (d.deviceid === deviceid ? { ...d, selected: false } : d));
		setDeviceList(updated);

		const selection = updated.filter((i) => i.selected).map((i) => i.deviceid);
		setCurrentDevices(selection.length ? selection : null);

		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		getEventsPost(1, currentFilter, currentEvents, selection.length ? selection : null);
	};

	const removeEventTypeChip = (typeKey) => {
		const updated = eventFilters.map((f) => (f.type === typeKey ? { ...f, selected: false } : f));
		setEventFilters(updated);

		const selection = updated.filter((i) => i.selected).map((i) => i.type);
		setCurrentEvents(selection.length ? selection : null);

		setLoading(true);
		setEventList([]);
		setCurrentPage(1);
		getEventsPost(1, currentFilter, selection.length ? selection : null, currentDevices);
	};

	return (
		<>
			<div className={`info-section scrollable-y ${MOBILE && (showAlarmFilter || showDeviceFilter || showDateFilter) ? "events-filters-open" : ""}`} id="resizable-element">
				<div className="d-flex margin-x-20 mt-3">
					<div className={`${showFilter && !filtersDone ? "d-none" : ""} d-flex align-items-center justify-content-end gap-2 w-100 mx-2`}>
						{FLAVOR === "alco" && (
							<>
								<NewButton notext={true} className={`full-rounded size36 ${highprio ? "bg-primary" : "bg-white"}`} icon={icons.priority} iconClass={`${highprio ? "white-icon" : "primary-icon"} size_15`} onClick={() => setHighprio(!highprio)} />
							</>
						)}
						{!massShare && <SearchbarNew searchWord={searchWord} submitSearch={(data) => setSearchWord(data)} />}
					</div>

					{!massShare && (
						<>
							<AnimatePresence initial={false} mode="wait" onExitComplete={() => setFiltersDone(true)}>
								{showFilter && (
									<motion.div key="filters" className="d-flex me-auto" initial={{ opacity: 1, x: 300 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 1, x: -300 }} transition={{ duration: 0.2, ease: "easeOut" }} onAnimationStart={() => setFiltersDone(false)}>
										<div className="position-relative">
											<NewButton className="full-rounded bg-white grey-blue" iconRight={true} icon={icons.chevron_down} iconClass={"ms-1 grey-blue-icon"} onClick={() => setShowAlarmFilter(!showAlarmFilter)}>
												{t("events.alarms")}
											</NewButton>
											<Collapse in={showAlarmFilter} className={`position-absolute start-0 zlatan mt-2`}>
												<div className="rounded2025 bg-white shadow d-flex flex-column sort-dropdown scrollable-y">
													{eventFilters?.map((type, index) => (
														<div key={index}>
															<div className="d-flex justify-content-between px-3 my-2 cursor-pointer" onClick={() => toggleEventFilter(type?.type)}>
																<div className={`body me-3 text-truncate ${type.selected ? "bold" : ""}`}>{type.name}</div>
																{type.selected && <img src={icons.check} alt="check" className="grey-blue-icon" />}
															</div>
															<hr className={`${index === eventFilters?.length - 1 ? "d-none" : ""} m-0 p-0`} />
														</div>
													))}
												</div>
											</Collapse>
										</div>

										<div className="position-relative">
											<NewButton className="full-rounded bg-white grey-blue ms-2" iconRight={true} icon={icons.chevron_down} iconClass={"ms-1 grey-blue-icon"} onClick={() => setShowDeviceFilter(!showDeviceFilter)}>
												{t("events.devices")}
											</NewButton>
											<Collapse in={showDeviceFilter} className={`position-absolute start-0 zlatan mt-2`}>
												<div className="rounded2025 bg-white shadow d-flex flex-column sort-dropdown scrollable-y">
													{deviceList?.map((device, index) => (
														<div key={index}>
															<div className="d-flex justify-content-between px-3 my-2 cursor-pointer" onClick={() => toggleDeviceFilter(device?.deviceid)}>
																<div className={`body me-3 text-truncate ${device.selected ? "bold" : ""}`}>{device.name}</div>
																{device.selected && <img src={icons.check} alt="check" className="grey-blue-icon" />}
															</div>
															<hr className={`${index === deviceList?.length - 1 ? "d-none" : ""} m-0 p-0`} />
														</div>
													))}
												</div>
											</Collapse>
										</div>
										<div className="position-relative">
											<NewButton className="full-rounded bg-white grey-blue ms-2" iconRight={true} icon={icons.chevron_down} iconClass={"ms-1 grey-blue-icon"} onClick={() => setShowDateFilter(!showDateFilter)}>
												{t("events.dates")}
											</NewButton>
											<Collapse in={showDateFilter} className={`position-absolute end-0 zlatan mt-2`}>
												<div className="rounded2025 bg-white shadow d-flex sort-dropdown scrollable-y justify-content-center">
													<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang}>
														<div className="d-flex flex-column my-3 justify-content-center gap-2">
															<div className={`d-flex px-2 pt-2 pb-1 bg-light-grey rounded8 flex-column justify-content-center`}>
																<p className="dark_grey bold">{t("devices.start")}</p>
																<DateTimePicker
																id="starttime"
																ampm={false}
																value={dates.startDate}
																onChange={(newValue) => {
																	if (!newValue) return;
																
																	setDates((d) => ({
																	...d,
																	startDate: newValue,
																	preset: null
																	}))
																}}
																minDateTime={undefined}
																maxDateTime={dates.endDate}
																className="date_label align-items-center m-0 p-0 dark_grey"
																format="DD/MM HH:mm"
																slotProps={{
																	openPickerButton: { disableRipple: true },
																}}
																/>
															</div>
															<div className="d-flex px-2 py-1 bg-light-grey rounded8 flex-column justify-content-center">
																<p className="dark_grey bold">{t("devices.end")}</p>
																<DateTimePicker 
																ampm={false} 
																value={dates.endDate} 
																onChange={(newValue) => setDates((d) => ({ ...d, endDate: newValue, preset: null }))} 
																minDateTime={dates.startDate} className="date_label align-items-center m-0 p-0" 
																format="DD/MM HH:mm" 
																slotProps={{
																	openPickerButton: {
																	disableRipple: true
																	}
																}}
																/>
															</div>
															<NewButton onClick={() => toggleDateFilter()} className="bg-grey-blue ms-auto px-3 py-2 rounded16 white body bold">
																{t("events.apply")}
															</NewButton>
															{/* <NewButton 
																notext={true}
																icon={icons.chevron_right}
																iconClass={"white-icon"}
																className={`ms-2 rounded8 bg-grey-blue size_25 align-self-end p-0`} 
																onClick={(event) => alert("hej")} /> */}
															{/* <NewButton 
																className="size_25 border-sm cursor-pointer align-self-end bg-grey-blue ms-4"
																notext={true}
																icon={icons.chevron_right}
																iconClass={"white-icon size_15"}
																onClick={() => getHistory()}
															/> */}
															
														</div>
													</LocalizationProvider>
												</div>
											</Collapse>
										</div>
									</motion.div>
								)}
							</AnimatePresence>
							<NewButton notext={true} className={`full-rounded size36 ${showFilter ? "bg-grey" : "bg-white"}`} icon={showFilter ? icons.close : icons.filter} iconClass={"grey-blue-icon size_15"} onClick={() => setShowFilter(!showFilter)} />
						</>
					)}
				</div>

				<div className="d-flex margin-x-20 mt-3 flex-wrap gap-2 align-items-center">
					{/* Search chip */}
					{searchWord?.trim() ? (
						<div className="rounded-pill px-2 py-1 bg-white d-flex align-items-center gap-2">
							<span className="body text-truncate">
								{searchWord}
							</span>
							<img src={icons.close} alt="remove" className="grey-blue-icon size_15 cursor-pointer" onClick={clearSearch} />
						</div>
					) : null}

					{/* Alarm type chips */}
					{eventFilters
						?.filter((f) => f.selected)
						.map((f) => (
							<div key={f.type} className="rounded-pill px-2 py-1 bg-white d-flex align-items-center gap-2 w-25">
								<span className="body text-truncate">
									{f.name}
								</span>
								<img src={icons.close} alt="remove" className="grey-blue-icon size_15 cursor-pointer" onClick={() => removeEventTypeChip(f.type)} />
							</div>
						))}

					{/* Device chips */}
					{selectedDeviceLabels.map((d) => (
						<div key={d.id} className="rounded-pill px-2 py-1 bg-white d-flex align-items-center gap-2 w-25">
							<span className="body text-truncate">
								{d.name}
							</span>
							<img src={icons.close} alt="remove" className="grey-blue-icon size_15 cursor-pointer" onClick={() => removeDeviceChip(d.id)} />
						</div>
					))}

					{/* Date range chip */}
					{selectedDateLabel ? (
						<div className="rounded-pill px-2 py-1 bg-white d-flex align-items-center gap-2">
							<span className="body text-truncate">{selectedDateLabel}</span>
							<img src={icons.close} alt="remove" className="grey-blue-icon size_15 cursor-pointer" onClick={clearDateFilter} />
						</div>
					) : null}
				</div>

				{massShare && <MassSharingContent show={massShare} />}

				<div ref={listInnerRef} onScroll={!MOBILE && !loading && !loadingBottom ? onScroll : undefined} className={`margin-x-20 flex-stretch rounded24 border-bottom-24 ${deleteToggle ? "pushed" : ""} margin-bottom-20 ${massShare ? "d-none" : ""}`}>
					{loading && (
						<div className="mt-3 rounded24 overflow-hidden">
							<EventRowPlaceholder />
						</div>
					)}

					{eventList &&
						Object.entries(eventsByMonth).map(([month, events], index) => (
							<div key={month}>
								<div key={index} className={`glossy-nocolor p-1 px-2 w-100 rounded8 mb-1 ${index !== 0 ? "mt-3" : ""}`}>
									<h4 className="m-0">{month}</h4>
								</div>
								<div className="rounded24 overflow-hidden">
									{events.map((event, i) => (
										<EventRowNew
											key={event.eventid ?? i}
											event={event}
											index={i}
											checkbox={showDelete}
											currentEvent={currentEvent}
											setCurrentEvent={setCurrentEvent}
											showOnMap={showOnMap}
											setEventToggle={selectEvent}
											selected={eventDeleteArray.includes(event.eventid)}
											setSelected={(id) => selectEventForDelete(id)}
										/>
									))}
									{loadingBottom && <EventRowPlaceholder />}
								</div>
							</div>
						))}

					<div ref={sentinelRef} style={{ height: 1 }} />
				</div>

				{(!eventList || eventList.length === 0) && !loading && <h3 className="bold dark-grey text-center mt-5">{t("events.no_events")}</h3>}

				<div className={`d-flex justify-content-end mt-3 ${!deleteToggle && "d-none"}`}>
					<Button btnClass="btn-secondary me-3" onClick={() => closeActions()}>
						{t("events.cancel")}
					</Button>
					<Button btnClass={`${eventListFull?.some((device) => device.selected) ? "" : "disabled"} btn-danger`} onClick={() => checkChecked()}>
						{t("events.delete_alarms")}
					</Button>
				</div>
			</div>

			<DeleteEvents show={modals.delete_events} onClose={() => toggleModal("delete_events")} deleteAll={deleteAllEvents} />
		</>
	);
};

export default EventsNewMobile;
